export default "__VITE_IMAGE_ASSET__49d3944b__";